export const vocabResponseKey = (vocabulary: string): string =>
    vocabulary.split('.').pop() ?? '';

export const buildVocabularyQueryItem = (
    vocabulary: string,
    extras: {page?: number; search?: string} = {},
) => ({
    page: extras.page ?? 1,
    vocabulary,
    search: extras.search ?? '',
});
